export const FEATURE_NAME = 'dashboard';
